import { render, staticRenderFns } from "./PlayerChatBlockPreview.vue?vue&type=template&id=b80566ac&scoped=true&"
import script from "./PlayerChatBlockPreview.vue?vue&type=script&lang=js&"
export * from "./PlayerChatBlockPreview.vue?vue&type=script&lang=js&"
import style0 from "./PlayerChatBlockPreview.vue?vue&type=style&index=0&id=b80566ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80566ac",
  null
  
)

export default component.exports